import React from 'react';
import { motion } from 'framer-motion';

export default function PersonaCard({ image, title, attribution, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      data-testid={`persona-card-${index}`}
      className="group relative overflow-hidden rounded-2xl aspect-[3/4] cursor-pointer"
    >
      {/* Image */}
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      
      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-default)] via-transparent to-transparent opacity-80" />
      
      {/* Purple tint on hover */}
      <div className="absolute inset-0 bg-[var(--primary-main)] opacity-0 group-hover:opacity-20 transition-opacity duration-500" />
      
      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
        <h3 className="text-base md:text-lg font-bold text-[var(--text-primary)] group-hover:text-[var(--accent-gold)] transition-colors duration-300">
          {title}
        </h3>
        
        {/* Accent line */}
        <div className="mt-2 h-0.5 w-8 group-hover:w-16 bg-[var(--accent-gold)] transition-all duration-500 rounded-full" />
        
        {/* Attribution */}
        {attribution && (
          <a
            href={attribution.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 block text-[10px] text-[var(--text-muted)] hover:text-[var(--text-secondary)] transition-colors"
          >
            {attribution.text}
          </a>
        )}
      </div>
      
      {/* Corner accent */}
      <div className="absolute top-4 right-4 w-3 h-3 border-t-2 border-r-2 border-[var(--accent-gold)] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <div className="absolute bottom-4 left-4 w-3 h-3 border-b-2 border-l-2 border-[var(--primary-light)] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </motion.div>
  );
}
